<template>
  <div>
  <facit-header></facit-header>
    <div class="profile-div col-sm-6">
      <h5 class="mt-3 mb-3"> Support </h5>
      <br>
      <b-form @submit.prevent="support('formRegistration')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formRegistration">
        <b-form-group id="nameGroup">
          <b-row class="my-0">
            <b-col sm="4">
              <label for="input-small">Support Type</label>
            </b-col>
          <b-col sm="8">
            <b-form-select v-model="supportType"
                           name="supportType"
                           id="supportType"
                           class="mb-2"
                           :options="options"
                           v-validate="'required'"
                           :class="{'input': true,
                                    'is-danger': errors.has('formRegistration.supportType') }"
                           required>
            </b-form-select>
            <i v-show="errors.has('formRegistration.supportType')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.supportType')"
                  class="help is-danger">{{ errors.first('formRegistration.supportType') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-0">
            <b-col sm="4">
              <label for="input-small">Message</label>
            </b-col>
            <b-col sm="8">
              <b-form-textarea id="message"
                          type="text"
                          name="message"
                          :rows="5"
                          v-model="message"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.message') }"
                          required
                          placeholder="Message">
               </b-form-textarea>
              <i v-show="errors.has('formRegistration.message')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.message')"
                    class="help is-danger">{{ errors.first('formRegistration.message') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"></label>
            </b-col>
            <b-col sm="8">
                        <vue-recaptcha
                          ref="recaptcha"
                          @verify="onVerify"
                          @expired="onExpired"
                          sitekey="6LfNiFMUAAAAAIvrde8Hq-aeNyI-OA5R30sKrLJv">
                        </vue-recaptcha>
              <i v-show="errors.has('formRegistration.message')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.message')"
                    class="help is-danger">{{ errors.first('formRegistration.message') }}
              </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-button
          type="submit"
          class="w-100"
          :disabled="disabledButton"
          variant="warning">Submit</b-button>
      </b-form>
      <b-modal hide-footer v-model="modalShow" @hidden="redirect()" title="Thank You">
      Thank you for contacting us, our support team will be in touch shortly.
    </b-modal>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'profile',
  components: { FacitHeader, VueRecaptcha },
  data() {
    return {
      firstName: null,
      lastName: null,
      message: null,
      supportType: null,
      email: null,
      modalShow: false,
      disabledButton: true,
      options: [
        { value: null, text: 'Select Support Type' },
        { value: 'Technical Support', text: 'Technical Support' },
        { value: 'Billing Support', text: 'Billing Support' },
        { value: 'Custom Package', text: 'Custom Package' },
        { value: 'Other', text: 'Other' },
      ],
    };
  },
  methods: {
    async support(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          const token = Session.getAccessToken();
          const usrId = token.user.id;
          const email = token.user.email;
          const firstName = token.user.firstname;
          const lastName = token.user.lastname;
          const billingEmail = token.user.billingEmail;
          await API.post(`Accounts/${usrId}/supportEmail`, {
            email: email,
            firstname: firstName,
            lastname: lastName,
            message: this.message,
            supportType: this.supportType,
            userId: usrId,
            billingEmail: billingEmail,
          });
          this.modalShow = true;
        }
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while sending Email',
        });
      }
    },
    async onVerify(response) {
      if (response) {
        this.disabledButton = false;
      }
    },
    onExpired() {

    },
    redirect() {
      this.$router.push('/');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/support.vue